import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { UsersReducer } from "../reducers/UsersReducer";

const UsersContext = createContext({
	state: UsersReducer.getInitialState(),
	actions: UsersReducer.actions,
});

export const useUsersContext = () => useContext(UsersContext);

export const UsersProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: UsersReducer.getInitialState(),
		reducers: UsersReducer.caseReducers,
	});

	return (
		<UsersContext.Provider value={{ state, actions }}>
			{children}
		</UsersContext.Provider>
	);
};
